export default __webpack_public_path__ + "static/media/reply-video.38316769.svg";